import httpClient from "@/http-client";

export const get = (Options = {}) => {
    return httpClient
        .get("/api/employee-leave-initial-balances", Options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export const generate = data => {
    return httpClient
        .post("/api/employee-leave-initial-balances/generate", data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export const update = (id, data) => {
    return httpClient
        .put(`/api/employee-leave-initial-balances/${id}`, data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export default {
    get,
    update,
    generate
};
